export const slugToWords = (slug: string): string => {
	const words = slug.replace(/[-_.]/g, ' ');
	return words.charAt(0).toUpperCase() + words.slice(1);
};
